import { merchantService } from 'commons/services';
import { KycFlagName } from 'commons/types';

export async function verifyIfKycFlagIsEnabled(
  name: KycFlagName,
): Promise<boolean> {
  const activeStore = await merchantService.getActiveStore();
  const kycFlag = activeStore.kycFlags.find((flag) => flag.name === name);
  if (!kycFlag) {
    return false;
  }
  return kycFlag.enabled;
}
